import { useOpenWindow } from "@utils/window";
import { PAGES } from "@routes";
import VideoCover from "@layouts/VideoCover";
import TitleTranslateBtn from "@components/TitleTranslateBtn";
import { FocusAction } from "./FocusAction";
import type { UICardProps } from "./types";

const UIVideoCard = ({ record }: UICardProps) => {
  const { openWindow } = useOpenWindow();

  return (
    <div
      key={record.id}
      className="kalo-white-card flex flex-col w-full group relative p-0! group overflow-hidden"
      onClick={() => {
        openWindow(`${PAGES.AI_VIDEO_INSIGHT}?id=${record.videoId}&videoSource=${record.videoSource || "Kalodata"}`);
      }}
    >
      <div className="relative">
        <VideoCover
          cover={record.coverImageUrl}
          className="w-full aspect-3/4 rounded-none! border-none!"
          videoId={record.videoId}
          videoSource={record.videoSource || "Kalodata"}
          showAdIcon={false}
          videoIconSize="size64"
          adIconSize="size24"
        ></VideoCover>
      </div>
      <div className="px-[12px] pt-[8px] pb-[12px] flex flex-col gap-[8px] border-t border-kds-border">
        <div className="flex flex-row flex-start group h-[42px]">
          <div className="line-clamp-2  cursor-pointer">{record.description}</div>
          <div className="shrink-0 mt-[2px]">
            <TitleTranslateBtn info={{ video_title: record.description, videoId: record.videoId, type: "video" }} />
          </div>
        </div>
      </div>

      <FocusAction
        className="absolute right-[11px] top-[11px] hidden group-hover:flex"
        id={record.collectionId}
        type="video"
      ></FocusAction>
    </div>
  );
};

export default UIVideoCard;
